import { login as loginApi, LoginReq } from "@/api/modules/page";
import { clearLoginCookie, getLoginCookie, setLoginCookie } from "./cookie";
import { isInIntlBrowser } from "./tools";
/**
 * 检查登录
 * @description encodeparam 为游戏内打开时从注入的登录态
 */
export function checkLogin() {
  const data = getLoginCookie();
  const { user_id, wt, encodeparam } = data;
  return (!!user_id && !!wt) || (Boolean(encodeparam) && isInIntlBrowser);
}

const info = () => {
  const data = getLoginCookie();
  return data;
};
const login = async (params: LoginReq) => {
  if (checkLogin()) {
    return info();
  }
  clearLoginCookie();
  const res = await loginApi(params);

  if (!res || res.code !== 0 || !res.data) {
    window.showMessgae("로그인에 실패하였습니다.");
    return res.code;
  }
  const { user_id, wt, result: resultCode } = res.data;
  if (resultCode !== 0) {
    if (resultCode === 3518906) {
      window.showMessgae('잘못된 인증번호입니다.');
      return resultCode;
    }
    window.showMessgae("잠시 후 다시 시도하세요.")
    return resultCode;
  }
  const { game_id, phone } = params;
  // 写入 cookie
  const result = Object.assign(
    {},
    {
      user_id,
      wt,
      game_id,
      phone,
      expires: new Date().getTime() + 7 * 24 * 60 * 60 * 1000,
    }
  );
  setLoginCookie(result);
  return 0; 
};

const showLogin = async (loginParam?: Record<string, any>) => {
  clearLoginCookie()
  return false;
};

const logout = async () => {
  clearLoginCookie()
  return;
};
export default {
  checkLogin,
  login,
  info,
  showLogin,
  logout
};
